import React from "react";
import { motion } from "framer-motion";
import { Instagram as InstagramIcon } from "lucide-react";
import { Reveal } from "../common/Reveal";
import { Img } from "../common/Img";
import { INSTAGRAM_POSTS } from "../../data/instagram";
import { COMPANY } from "../../config/company";
import { useLanguage } from "../../context/LanguageContext";
import { fadeUp, viewport, stagger } from "../../lib/animations";

// The grid uses curated imagery; every click opens the real Instagram profile.
export default function InstagramFeed() {
  const { t } = useLanguage();

  return (
    <section className="py-24 md:py-32 bg-[#FFFFFF]" data-testid="instagram-section">
      <div className="container-tessa">
        <Reveal className="text-center mb-12">
          <span className="font-sans text-xs uppercase tracking-[0.24em] text-[#D92A47] block">
            {t("instagram.eyebrow")}
          </span>
          <a
            href={COMPANY.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-handle"
            className="mt-3 inline-flex items-center gap-2 font-serif text-4xl md:text-5xl text-[#183C32] hover:text-[#D92A47] transition-colors"
          >
            <InstagramIcon size={30} strokeWidth={1.4} />
            {COMPANY.instagram}
          </a>
        </Reveal>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={stagger(0.07)}
          className="grid grid-cols-2 md:grid-cols-4 auto-rows-[46vw] md:auto-rows-[220px] gap-2 md:gap-3"
        >
          {INSTAGRAM_POSTS.map((post) => (
            <motion.a
              key={post.id}
              href={COMPANY.instagramUrl}
              target="_blank"
              rel="noreferrer"
              variants={fadeUp}
              data-testid={`instagram-${post.id}`}
              className={`group relative overflow-hidden ${post.span}`}
              aria-label={post.altEn}
            >
              <Img
                src={post.image}
                alt={post.altEn}
                className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-500 grid place-items-center">
                <InstagramIcon size={26} className="text-[#F6F2EC] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
